import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=c8a88b66&scoped=true&"
import script from "./AppNavigation.vue?vue&type=script&lang=ts&"
export * from "./AppNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=c8a88b66&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a88b66",
  null
  
)

export default component.exports